import React, { useState } from 'react';
import s from './HelpModal.module.scss';
import cx from 'classnames'
import EventBus from 'scripts/util/EventBus'

import SecondaryFeatures from 'components/SecondaryFeatures';

const key = {
  0: 'trickSitPretty',
  1: 'trickBackflip',
  2: 'trickSpin',
  3: 'trickSpeak',
  4: 'tryPet',
  6: 'tryToy',
}

export default function HelpModal({ closeModal, unlockedTricks, lockMenu, setModals, modals }) {

  const [menuExpand, setMenuExpand] = useState(false)

  const handleItem = ( number ) => {
    
    EventBus.dispatch("Action", { type: 'hintTrick', number })
    if (modals.length > 0) {
      closeModal()
      return
    }
    setModals([key[number]])
    setTimeout(() => {
      setModals((arr) => arr.filter((el) => el !== key[number]))
    }, 4000)
    closeModal()
  }

  function isNotUnlocked(name) {
    if (lockMenu) return true
    return !unlockedTricks.includes(name)
  } 
  
  return (
    <div className={s.help}>
      <div className={s.container}>
        <div className={s.top}>
          <h3>Learn to play with Robo Dog.</h3>
          <div className={s.items}>
            <div className={s.item} onClick={() => { setMenuExpand(!menuExpand) }}>
              <div className={s.itemHeader}>Tricks</div>
              <div className={cx(s.itemPanel, {[s.expand]:menuExpand})}>
              <svg xmlns="http://www.w3.org/2000/svg" width="7.948" height="13.775" viewBox="0 0 7.948 13.775">
                <path id="Path_228" data-name="Path 228" d="M1224.245,427.2l6.357,6.357,6.357-6.357" transform="translate(-426.674 1237.489) rotate(-90)" fill="none" stroke="#fff" stroke-width="1.5"/>
              </svg>
                <ul>
                <li>
                  <button disabled={isNotUnlocked('tryPet')} onClick={(e) => {
                    e.preventDefault()
                    handleItem(4)
                  }}>{isNotUnlocked('tryPet') ? 'Locked' : 'Pet'}</button></li>
                <li>
                  <button disabled={isNotUnlocked('trickSitPretty')} onClick={(e) => {
                    e.preventDefault()
                    handleItem(0)
                  }}>{isNotUnlocked('trickSitPretty') ? 'Locked' : 'Sit Pretty'}</button></li>
                   <li><button disabled={isNotUnlocked('trickBackflip')} onClick={(e) => {
                    e.preventDefault()
                    handleItem(1)
                  }}>{isNotUnlocked('trickBackflip') ? 'Locked' : 'Flip'}</button></li>
                   <li><button disabled={isNotUnlocked('trickSpin')} onClick={(e) => {
                    e.preventDefault()
                    handleItem(2)
                  }}>{isNotUnlocked('trickSpin') ? 'Locked' : 'Spin'}</button></li>
                   <li><button disabled={isNotUnlocked('trickSpeak')} onClick={(e) => {
                    e.preventDefault()
                    handleItem(3)
                  }}>{isNotUnlocked('trickSpeak') ? 'Locked' : 'Speak'}</button></li>
                </ul>
                {unlockedTricks.length !== 5 && <p>Keep playing to unlock them all!</p>} 
              </div>
            </div>
            <div className={s.item}>
              <div className={s.itemHeader} onClick={() => {
                handleItem(6)
              }}>Toys</div>
            </div>
          </div>
        </div>
        <div className={s.bottom}>
          <SecondaryFeatures />
        </div>
      </div>
    </div>
  );
}